export var tagLocale = {
  removeLabel: 'Remove'
};